module.exports = __webpack_public_path__ + "static/img03-6de6acd3ebd05485fb42298bdab2cf25.png";